import axios, { AxiosResponse } from 'axios'
import { ApiConfig } from '../../config/api'
import { Warehouse } from '../../interfaces/Warehouse/Warehouse'
import { DataGridElements } from '../../interfaces'

// Trae TODOS los almacenes (activos + inactivos), bypasseando el caché Redux
// compartido (warehousesState, que solo expone activos — ver redux/services/warehouseServices.ts).
// Usar SOLO en los filtros de búsqueda de Zona y Posiciones (admin).
export const getAllWarehouses = (): Promise<AxiosResponse<DataGridElements<Warehouse>>> =>
  axios.get(`${ApiConfig.WareHouseApi}?pageSize=50`)
